export default [
  {
    path: '/carrinho/:idFatura?/:progresso?',
    name: 'carrinho',
    component: () => import(/* webpackChunkName: "carrinho" */ '../../views/carrinho/Carrinho')
  },

  {
    path: '/carrinho/:idPlano',
    name: 'carrinho/upgrade',
    component: () => import(/* webpackChunkName: "carrinho" */ '../../views/carrinho/Carrinho')
  }
]
